import AttachmentsModule from '~/lib/vue/modules/attachments';

export default (services, namespace='attachments') => {
  return AttachmentsModule.create({services});
};
